<template>
  <div class="ProductsSkeleton" aria-busy="true" aria-label="Cargando productos">
    <div class="products-skeleton-toolbar">
      <div class="skeleton-line skeleton-line--sm" style="width: 160px;"></div>
      <div class="products-skeleton-pages">
        <div
          v-for="n in 5"
          :key="'page-' + n"
          class="skeleton-page"
        ></div>
      </div>
    </div>

    <div class="row">
      <div
        class="col-sm-6 col-md-4 col-lg-4"
        v-for="n in loopCount"
        :key="'card-' + n"
      >
        <div class="products-skeleton-card">
          <div class="skeleton-image"></div>
          <div class="products-skeleton-body">
            <div class="skeleton-line skeleton-line--md" style="width: 92%;"></div>
            <div class="skeleton-line skeleton-line--sm" style="width: 70%; margin-top: 10px;"></div>
            <div class="skeleton-line skeleton-line--md" style="width: 40%; margin-top: 16px;"></div>
            <div class="skeleton-btn"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductsSkeleton',
  props: {
    loopCount: {
      type: Number,
      default: 12,
    },
  },
};
</script>

<style lang="scss" src="./ProductsSkeleton.scss"></style>
